// MenuItem.js
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const MenuItem = ({ title, icon, clickHandler }) => (
    <div
        className="menu-item has-text-white"
        onClick={clickHandler}
        style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "8px" }}
    >
        <FontAwesomeIcon icon={icon} />
        {title && <span>{title}</span>}
    </div>
);

export default MenuItem;
